module.exports = __webpack_public_path__ + "static/omahetki-cbf7a2d15196707e7a9728be99a61c17.jpg";